let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4fGj1")).then(() => parcelRequire('1cezk'));